import React from 'react';
import { PillTabs, PillTabsData } from '../../../../../components/common';

import './tabbed-layout.scss';

interface TabbedLayoutProps {
    tabs: PillTabsData[];
    activeTabId?: string;
    onTabClick?: (tabId: string) => void;
    otherControls?: (tab: PillTabsData) => JSX.Element;
}

export const TabbedLayout: React.FC<TabbedLayoutProps> = ({
    tabs,
    activeTabId,
    onTabClick,
    otherControls,
}): React.ReactElement => {
    return (
        <div className="tabbed-layout">
            <PillTabs tabs={tabs} activeTabId={activeTabId} onTabClick={onTabClick} otherControls={otherControls} />
        </div>
    );
};
